// extracted by mini-css-extract-plugin
export default {"table":"LoginPage_table__Dk5Cx","loginPage":"LoginPage_loginPage__CKycu"};